import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'

class Textarea extends Component {
  constructor (props) {
    super(props)

    this.comment = props.comment
    const fieldValue = this.props.field.value
    const initialCharCount = fieldValue ? fieldValue.length : 0
    this.state = {
      char_count: initialCharCount
    }

    this.updateCharCount = this.updateCharCount.bind(this)
  }

  componentWillReceiveProps = nextProps => {
    const fieldValue = nextProps.field.value
    const initialCharCount = fieldValue ? fieldValue.length : 0
    this.setState({
      char_count: initialCharCount
    })
  }

  updateCharCount (newValue) {
    this.setState({
      char_count: newValue.length
    })
  }

  render () {
    const languageContent = this.props.pageContent.content
    const field = this.props.field
    const required = ((field.rules.required !== undefined) && (field.rules.required.required === true || field.rules.required.required !== false))
    field.errors = field.errors || []
    const hideCharCount = field.hideCharCount ? field.hideCharCount : false;
    const hasErrors = field.errors.length > 0
    var maxLength = this.props.maxLength || 4000

    return (
      <div className={hasErrors ? 'form-group has-danger' : 'form-group'}>
        {
          field.rules.title &&
          <label className='form-control-label textarea-label'>{field.rules.title + (required ? '*' : '')}</label>
        }
        <textarea
          name={field.name}
          rows={this.props.rows}
          maxLength={maxLength}
          className={hasErrors ? 'form-control form-control-danger' : 'form-control'}
          style={this.props.style}
          value={field.value}
          placeholder={this.props.placeholder}
          onBlur={(e, field) => this.props.validate(e, field)}
          onChange={(e, field) => this.props.validate(e, field)}
          onKeyUp={e => this.updateCharCount(e.currentTarget.value)}
          disabled={this.props.isDisabled}
        />
        {!hideCharCount && 
        <div style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
        >
          <div>{this.comment}&nbsp;</div>
          <div>
            <span className='right character-validate'>{this.state.char_count + '/' + maxLength} {languageContent.module.submitInquiry.characters}</span>
          </div>
        </div>
  }
        {field.errors.map((error, i) =>
          <div key={i} className='form-control-feedback left'>{error}</div>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    pageContent: state.pageContent
  }
}

export default connect(mapStateToProps)(Textarea)



// WEBPACK FOOTER //
// ./src/forms/Textarea.js